<app-field-container [field]="this">
  <div class="position-relative">
    <div class="search-container">
      <input
        type="search"
        [formControl]="searchControl"
        (keyup)="search($event)"
        class="form-control form-control-lg"
        [placeholder]="selectedLabel() ? '' : (placeholder() ?? '')" #inputElement/>
      <span class="search-icon">
        <lucide-icon [name]="icons.search"></lucide-icon>
      </span>
      @if (selectedLabel()) {
        <button type="button" class="btn btn-sm btn-outline-primary btn-clear" aria-label="Close" (click)="clear(inputElement)">
          {{ selectedLabel() }} <lucide-icon [name]="icons.close"></lucide-icon>
        </button>
      }
    </div>
    @if (showList()) {
      <div class="list-container position-absolute w-100">
        <ul class="list-group">
          @if (showSpinner()) {
            <li class="list-group-item">
              <div class="spinner-border text-tertiary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </li>
          } @else {
            @if (createChoiceLabel()) {
              <li class="list-group-item list-group-item-primary list-group-item-action" (click)="triggerCreate(inputElement)">
                <i>{{ createChoiceLabel() }}</i>
              </li>
            }
            @if (choices()) {
              @for (choice of choices(); track choice) {
                <li [title]="choice.hint ?? null" class="list-group-item list-group-item-primary list-group-item-action" (click)="select(choice, inputElement)">
                  @if (choice.icon) {
                    <lucide-icon [img]="choice.icon"></lucide-icon>
                  }
                  <span class="ms-2">{{ choice.text }}</span>
                </li>
              }
            }
          }
        </ul>
      </div>

    }

<!--    @if (showMap()) {-->
<!--      <div class="my-2">-->
<!--        <app-map [coords]="coordinates()"></app-map>-->
<!--      </div>-->
<!--    }-->
  </div>
</app-field-container>

<!--<app-field-container [field]="this" *transloco="let t">-->
<!--  <div class="position-relative">-->
<!--    <div class="input-group">-->
<!--      <span class="input-group-text"><lucide-icon [img]="icons.search"></lucide-icon></span>-->
<!--      <input type="text"-->
<!--             (keyup)="search($event)"-->
<!--             class="form-control"-->
<!--             [placeholder]="placeholder()"/>-->
<!--    </div>-->
<!--    @if (hasResults()) {-->
<!--      <div class="list-group position-absolute w-100">-->
<!--        @if (canCreate() && searchTerm()) {-->
<!--          <button type="button" (click)="createItem()" class="list-group-item list-group-item-action" aria-current="true">-->
<!--            Create {{ searchTerm() }}-->
<!--          </button>-->
<!--        }-->
<!--        @for (item of items(); track item.id) {-->
<!--          <button type="button" (click)="selectItem(item)" class="list-group-item list-group-item-action" aria-current="true">-->
<!--            <span class="badge {{ itemBadgeClass(item) }} rounded-pill me-2">{{ itemBadgeText(item) }}</span>-->
<!--            {{ item.label }}-->
<!--          </button>-->
<!--        }-->
<!--      </div>-->
<!--    }-->
<!--  </div>-->
<!--</app-field-container>-->
